function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.78,
    height: 16.37,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3385714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 8.185
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.37,
    width: 28.78,
    height: 16.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 24.755000000000003
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.14,
    width: 28.78,
    height: 19.61,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 42.945
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.75,
    width: 28.78,
    height: 26.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9155555555555552
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 65.87
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78.99,
    width: 28.78,
    height: 26.98,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.396
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 92.47999999999999
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105.97,
    width: 28.78,
    height: 27.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 119.965
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 133.96,
    width: 28.78,
    height: 28.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.866
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 148.29000000000002
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.62,
    width: 28.78,
    height: 29.67,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.796666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 177.455
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192.29,
    width: 28.78,
    height: 32.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 208.67499999999998
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 225.06,
    width: 28.78,
    height: 34.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.111428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 242.38
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 259.7,
    width: 28.78,
    height: 34.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.756
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 277.055
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 294.41,
    width: 28.78,
    height: 36.24,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 312.53000000000003
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 330.64,
    width: 28.78,
    height: 37.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.796666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 349.37
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 368.1,
    width: 28.78,
    height: 43.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.796666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 389.685
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 411.27,
    width: 28.78,
    height: 43.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.878
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 433.07
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.87,
    width: 28.78,
    height: 45.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.756
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 477.74
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 500.6,
    width: 28.78,
    height: 47.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.197777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 524.145
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 547.69,
    width: 28.78,
    height: 49.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.756
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 572.6550000000001
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 597.62,
    width: 28.78,
    height: 50.93,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.796666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 623.085
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 648.55,
    width: 28.78,
    height: 51.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.111428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.39,
    y: 674.275
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 0,
    width: 36.14,
    height: 45.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.023333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.85,
    y: 22.64
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.92,
    y: 0,
    width: 37.57,
    height: 45.28,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.69625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 83.705,
    y: 22.64
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 0,
    width: 37.97,
    height: 45.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.74625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.485,
    y: 22.64
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.47,
    y: 0,
    width: 38.53,
    height: 45.28,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.81625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.735,
    y: 22.64
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 0,
    width: 39.24,
    height: 45.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.62,
    y: 22.64
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.24,
    y: 0,
    width: 43.43,
    height: 45.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.955,
    y: 22.64
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.67,
    y: 0,
    width: 43.92,
    height: 45.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.63,
    y: 22.64
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.58,
    y: 0,
    width: 44.55,
    height: 45.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.85499999999996,
    y: 22.64
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 0,
    width: 47.34,
    height: 45.28,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.116363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.8,
    y: 22.64
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.47,
    y: 0,
    width: 48.09,
    height: 45.28,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.51500000000004,
    y: 22.64
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.57,
    y: 0,
    width: 50.5,
    height: 45.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5280000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.82,
    y: 22.64
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496.07,
    y: 0,
    width: 50.52,
    height: 45.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.33,
    y: 22.64
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.59,
    y: 0,
    width: 50.69,
    height: 45.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.056000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.9350000000001,
    y: 22.64
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.28,
    y: 0,
    width: 50.78,
    height: 45.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.67,
    y: 22.64
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648.05,
    y: 0,
    width: 51.95,
    height: 45.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.025,
    y: 22.64
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 45.28,
    width: 52.99,
    height: 44.79,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 67.675
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 90.07,
    width: 52.99,
    height: 46.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.642857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 113.32
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 136.57,
    width: 52.99,
    height: 46.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.206666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 160
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 183.43,
    width: 52.99,
    height: 47.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7490000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 207.175
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 230.92,
    width: 52.99,
    height: 48.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.395555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 255.2
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 279.48,
    width: 52.99,
    height: 48.56,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.186666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 303.76
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 328.05,
    width: 52.99,
    height: 48.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.794
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 352.535
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 377.02,
    width: 52.99,
    height: 51.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7411111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 402.85499999999996
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 428.69,
    width: 52.99,
    height: 51.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.382857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 454.53
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 480.37,
    width: 52.99,
    height: 52.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 506.425
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 532.48,
    width: 52.99,
    height: 52.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.498571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 558.725
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 584.97,
    width: 52.99,
    height: 56.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.598
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 613
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.78,
    y: 641.03,
    width: 52.99,
    height: 58.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.2475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.275000000000006,
    y: 670.515
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 45.28,
    width: 56.53,
    height: 57.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.075714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.035,
    y: 73.89
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.31,
    y: 45.28,
    width: 57.09,
    height: 57.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.85500000000002,
    y: 73.89
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.4,
    y: 45.28,
    width: 57.47,
    height: 57.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.536666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 224.135,
    y: 73.89
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.87,
    y: 45.28,
    width: 58.21,
    height: 57.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.975,
    y: 73.89
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.08,
    y: 45.28,
    width: 58.46,
    height: 57.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.536666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.31,
    y: 73.89
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.54,
    y: 45.28,
    width: 63.04,
    height: 57.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.06,
    y: 73.89
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.58,
    y: 45.28,
    width: 63.23,
    height: 57.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.195,
    y: 73.89
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.81,
    y: 45.28,
    width: 66.06,
    height: 57.22,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.536666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.84,
    y: 73.89
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 561.86,
    y: 45.28,
    width: 68.74,
    height: 57.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.443999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.23,
    y: 73.89
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.6,
    y: 45.28,
    width: 69.4,
    height: 57.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.443999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.3000000000001,
    y: 73.89
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 102.49,
    width: 66.02,
    height: 60.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.57875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 132.805
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 163.12,
    width: 66.02,
    height: 61.29,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 193.76500000000001
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 224.41,
    width: 66.02,
    height: 63.1,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 255.96
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 287.5,
    width: 66.02,
    height: 63.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.626666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 319.38
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 351.26,
    width: 66.02,
    height: 68.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.43142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 385.57
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 419.88,
    width: 66.02,
    height: 68.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.003333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 454.345
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 488.81,
    width: 66.02,
    height: 69.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.43142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 523.605
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 558.4,
    width: 66.02,
    height: 70.19,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 593.495
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.77,
    y: 628.59,
    width: 66.02,
    height: 71.41,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.43142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.78,
    y: 664.2950000000001
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 102.49,
    width: 74.22,
    height: 68.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.643333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.91000000000003,
    y: 136.885
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.01,
    y: 102.49,
    width: 74.94,
    height: 68.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.465000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.48,
    y: 136.885
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.96,
    y: 102.49,
    width: 77.78,
    height: 68.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.1975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.84999999999997,
    y: 136.885
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.74,
    y: 102.49,
    width: 78.49,
    height: 68.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.827142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.985,
    y: 136.885
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.23,
    y: 102.49,
    width: 81.18,
    height: 68.79,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.827142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.82000000000005,
    y: 136.885
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.42,
    y: 102.49,
    width: 82.32,
    height: 68.79,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.1975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.5799999999999,
    y: 136.885
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.73,
    y: 102.49,
    width: 83.27,
    height: 68.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.8790000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.365,
    y: 136.885
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 171.29,
    width: 81.64,
    height: 71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.62,
    y: 206.79
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 242.29,
    width: 81.64,
    height: 73.07,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.613999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.62,
    y: 278.825
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 315.36,
    width: 81.64,
    height: 73.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.464285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.62,
    y: 351.985
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 388.61,
    width: 81.64,
    height: 74.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.62,
    y: 426.06
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 463.51,
    width: 81.64,
    height: 75.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.39875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.62,
    y: 501.105
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 538.7,
    width: 81.64,
    height: 78.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.757777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.62,
    y: 578.11
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 617.52,
    width: 81.64,
    height: 82.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.205
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.62,
    y: 658.76
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.43,
    y: 171.29,
    width: 85.85,
    height: 80.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.478333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.355,
    y: 211.725
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.29,
    y: 171.29,
    width: 87.15,
    height: 80.87,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.087
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.865,
    y: 211.725
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.44,
    y: 171.29,
    width: 97.36,
    height: 80.87,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.12,
    y: 211.725
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.8,
    y: 171.29,
    width: 97.62,
    height: 80.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.087
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 548.61,
    y: 211.725
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.42,
    y: 171.29,
    width: 102.58,
    height: 80.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.552857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.7099999999999,
    y: 211.725
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.43,
    y: 252.16,
    width: 103.29,
    height: 81.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.075,
    y: 292.74
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.43,
    y: 333.32,
    width: 103.29,
    height: 82.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.483636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.075,
    y: 374.48
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.43,
    y: 415.63,
    width: 103.29,
    height: 83.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.075,
    y: 457.40999999999997
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.43,
    y: 499.2,
    width: 103.29,
    height: 99.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.802
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.075,
    y: 548.705
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.43,
    y: 598.21,
    width: 103.29,
    height: 101.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.72375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.075,
    y: 649.105
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.72,
    y: 252.16,
    width: 112.51,
    height: 94.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 388.975,
    y: 299.58
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.24,
    y: 252.16,
    width: 119.41,
    height: 94.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.54857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.945,
    y: 299.58
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.65,
    y: 252.16,
    width: 135.35,
    height: 94.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.806666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.3249999999999,
    y: 299.58
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.72,
    y: 347,
    width: 139.63,
    height: 93.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.655000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.535,
    y: 393.96500000000003
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.72,
    y: 440.93,
    width: 139.63,
    height: 125.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.535,
    y: 503.73
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.72,
    y: 566.52,
    width: 139.63,
    height: 133.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.535,
    y: 633.26
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.36,
    y: 347,
    width: 102.47,
    height: 207.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.638571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.595,
    y: 450.86
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.83,
    y: 347,
    width: 125.17,
    height: 207.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.64625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.4150000000001,
    y: 450.86
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.36,
    y: 554.71,
    width: 227.64,
    height: 145.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.208181818181817
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.1800000000001,
    y: 627.355
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1964);
export default __webpack_public_path__ + "static/media/1964.d9ca0690969ec0e9fb51a4d25f4ae45a.svg";
export { ForwardRef as ReactComponent };